    import React from 'react'
    import { Swiper, SwiperSlide } from 'swiper/react';
    import 'swiper/swiper-bundle.css';
    import { Navigation, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
    import 'swiper/css';
    import 'swiper/css/navigation';
    import 'swiper/css/scrollbar';
    import { Link } from 'react-router-dom';

    function ServiceThree() {
        return (
            <div>
                {/* rts-service area start */}
                <div className="rts-service-area rts-section-gap pb--140">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="text-center title-service-three">
                                    <p className="pre-title">Indústrias / Setores atendidos</p>
                                    <h2 className="title">Para o pilar empresarial, setores como:</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row g-5 mt--20">
                            <div className="col-12">
                                <div className="swiper ">
                                    <Swiper
                                        // install Swiper modules
                                        modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
                                        className="mySwiperh2_Service"
                                        speed={200}
                                        slidesPerView={3}
                                        spaceBetween={30}
                                        loop={true}
                                        autoplay={true}
                                        navigation={{
                                            nextEl: '.swiper-button-next',
                                            prevEl: '.swiper-button-prev',
                                        }}
                                        breakpoints={{
                                            1200: { slidesPerView: 3 },
                                            900: { slidesPerView: 3 },
                                            768: { slidesPerView: 2 },
                                            580: { slidesPerView: 2 },
                                            450: { slidesPerView: 1 },
                                            0: { slidesPerView: 1 },
                                        }}
                                    >
                                       <SwiperSlide>
    <div className="service-one-inner-four">
        <div className="big-thumbnail-area">
            <Link  className="thumbnail">
                <img
                    src="assets/images/home/4/1.png"
                    alt="Setor Indústrias"
                />
            </Link>
            <div className="content">
                <img
                    src="assets/images/home/5.png"
                    alt="Ícone Indústrias"
                />
                <h5 className="title">Indústrias</h5>
                <p className="disc">
                    Soluções financeiras e estratégicas para indústrias que buscam expansão, capital e eficiência operacional.
                </p>
            </div>
        </div>
    </div>
</SwiperSlide>

<SwiperSlide>
    <div className="service-one-inner-four">
        <div className="big-thumbnail-area">
            <Link className="thumbnail">
                <img
                    src="assets/images/home/4/2.png"
                    alt="Setor Comércio"
                />
            </Link>
            <div className="content">
                <img
                    src="assets/images/home/5.png"
                    alt="Ícone Comércio"
                />
                <h5 className="title">Comércio</h5>
                <p className="disc">
                    Atuação consultiva para varejo e atacado, com linhas de crédito e análise estratégica para crescimento.
                </p>
            </div>
        </div>
    </div>
</SwiperSlide>

<SwiperSlide>
    <div className="service-one-inner-four">
        <div className="big-thumbnail-area">
            <Link className="thumbnail">
                <img
                    src="assets/images/home/4/3.png"
                    alt="Setor Serviços"
                />
            </Link>
            <div className="content">
                <img
                     src="assets/images/home/5.png"
                    alt="Ícone Serviços"
                />
                <h5 className="title">Serviços</h5>
                <p className="disc">
                    Crédito empresarial, consultoria financeira e inteligência de mercado para prestadores de serviços.
                </p>
            </div>
        </div>
    </div>
</SwiperSlide>

<SwiperSlide>
    <div className="service-one-inner-four">
        <div className="big-thumbnail-area">
            <Link className="thumbnail">
                <img
                    src="assets/images/home/4/4.png"
                    alt="Setor Agronegócio"
                />
            </Link>
            <div className="content">
                <img
                    src="assets/images/home/5.png"
                    alt="Ícone Agronegócio"
                />
                <h5 className="title">Agronegócio</h5>
                <p className="disc">
                    Custeio, investimento, expansão de produção e soluções completas para produtores rurais.
                </p>
            </div>
        </div>
    </div>
</SwiperSlide>



<SwiperSlide>
    <div className="service-one-inner-four">
        <div className="big-thumbnail-area">
            <Link  className="thumbnail">
                <img
                    src="assets/images/home/4/6.png"
                    alt="Setor Mercado Imobiliário"
                />
            </Link>
            <div className="content">
                <img
                    src="assets/images/home/5.png"
                    alt="Ícone Mercado Imobiliário"
                />
                <h5 className="title">Mercado Imobiliário</h5>
                <p className="disc">
                    Crédito imobiliário, análise estratégica e consultoria para incorporadores, investidores e compradores.
                </p>
            </div>
        </div>
    </div>
</SwiperSlide>


                                    </Swiper>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--80">
                            <div className="col-12">
                                <div className="pagination-arrow navigation-center-bottom service text-center position-relative">
                                    <div className="swiper-button-next" />
                                    <div className="swiper-pagination" />
                                    <div className="swiper-button-prev" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* rts-service area end */}
            </div>
        )
    }

    export default ServiceThree